// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: var(--header-height);
  background: var(--sidebar-bg-start); /* Dark blue to match sidebar */
  border-bottom: 2px solid var(--accent);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.3s ease;
}

/* Izquierda */
.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.sidebar-toggle {
  background: transparent;
  border: none;
  color: var(--accent);
  cursor: pointer;
  padding: 8px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition);
}

.sidebar-toggle:hover {
  background: rgba(255, 255, 255, 0.1);
  color: var(--white);
}

.theme-toggle {
  background: transparent;
  border: none;
  color: var(--accent);
  cursor: pointer;
  padding: 8px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition);
}

.theme-toggle:hover {
  background: rgba(255, 255, 255, 0.1);
  color: var(--white);
}

.logo-ministerio {
  height: 48px;
  object-fit: contain;
}

/* Derecha */
.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.logo-hidroven {
  height: 40px;
  object-fit: contain;
}

.header-divider {
  width: 1px;
  height: 32px;
  background: var(--border);
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-info-text {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.user-name {
  font-size: 13px;
  font-weight: 700;
  color: var(--white);
  line-height: 1.2;
}

.user-role-pill {
  font-size: 10px;
  font-weight: 700;
  color: var(--primary);
  background: var(--accent-light);
  padding: 2px 8px;
  border-radius: var(--radius-full);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 2px;
}

.avatar-wrapper {
  position: relative;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-full);
  background: var(--primary-ultralight);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 14px;
  border: 2px solid transparent;
  transition: var(--transition);
}

.user-profile:hover .user-avatar {
  border-color: var(--accent);
  background: var(--white);
  box-shadow: 0 2px 8px rgba(74, 173, 227, 0.2);
}

.online-indicator {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 12px;
  height: 12px;
  background: var(--success);
  border: 2px solid var(--primary-dark);
  border-radius: 50%;
}

.btn-logout {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: var(--gray-300);
  border-radius: var(--radius);
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: var(--transition);
}

.btn-logout:hover {
  background: var(--danger);
  border-color: var(--danger);
  color: var(--white);
}

@media (max-width: 992px) {
  .user-info-text {
    display: none;
  }
}

@media (max-width: 768px) {
  .logo-ministerio {
    height: 36px;
  }
  .logo-hidroven {
    display: none;
  }
  .header-divider {
    display: none;
  }
  .logout-text {
    display: none;
  }
  .btn-logout {
    padding: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,mCAAmC,EAAE,+BAA+B;EACpE,sCAAsC;EACtC,yCAAyC;EACzC,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,qCAAqC;EACrC,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,0CAA0C;EAC1C,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 20px;\n  height: var(--header-height);\n  background: var(--sidebar-bg-start); /* Dark blue to match sidebar */\n  border-bottom: 2px solid var(--accent);\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  transition: all 0.3s ease;\n}\n\n/* Izquierda */\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.sidebar-toggle {\n  background: transparent;\n  border: none;\n  color: var(--accent);\n  cursor: pointer;\n  padding: 8px;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: var(--transition);\n}\n\n.sidebar-toggle:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: var(--white);\n}\n\n.theme-toggle {\n  background: transparent;\n  border: none;\n  color: var(--accent);\n  cursor: pointer;\n  padding: 8px;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: var(--transition);\n}\n\n.theme-toggle:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: var(--white);\n}\n\n.logo-ministerio {\n  height: 48px;\n  object-fit: contain;\n}\n\n/* Derecha */\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.logo-hidroven {\n  height: 40px;\n  object-fit: contain;\n}\n\n.header-divider {\n  width: 1px;\n  height: 32px;\n  background: var(--border);\n}\n\n.user-profile {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.user-info-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.user-name {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--white);\n  line-height: 1.2;\n}\n\n.user-role-pill {\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--primary);\n  background: var(--accent-light);\n  padding: 2px 8px;\n  border-radius: var(--radius-full);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-top: 2px;\n}\n\n.avatar-wrapper {\n  position: relative;\n}\n\n.user-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-full);\n  background: var(--primary-ultralight);\n  color: var(--primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 14px;\n  border: 2px solid transparent;\n  transition: var(--transition);\n}\n\n.user-profile:hover .user-avatar {\n  border-color: var(--accent);\n  background: var(--white);\n  box-shadow: 0 2px 8px rgba(74, 173, 227, 0.2);\n}\n\n.online-indicator {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 12px;\n  height: 12px;\n  background: var(--success);\n  border: 2px solid var(--primary-dark);\n  border-radius: 50%;\n}\n\n.btn-logout {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: var(--gray-300);\n  border-radius: var(--radius);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  transition: var(--transition);\n}\n\n.btn-logout:hover {\n  background: var(--danger);\n  border-color: var(--danger);\n  color: var(--white);\n}\n\n@media (max-width: 992px) {\n  .user-info-text {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .logo-ministerio {\n    height: 36px;\n  }\n  .logo-hidroven {\n    display: none;\n  }\n  .header-divider {\n    display: none;\n  }\n  .logout-text {\n    display: none;\n  }\n  .btn-logout {\n    padding: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
